module.exports = __webpack_public_path__ + "static/media/ourbrands-logo1.fd9448f0.png";